function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SlovakiaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1465",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1465)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1465",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1465)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.7029 7.52274L11.9515 7.49629L11.9277 7.27274H11.7029H4.75862H4.52491L4.50919 7.50592L4.75862 7.52274L4.50918 7.50598L4.50917 7.50613L4.50913 7.50672L4.50898 7.50899L4.50839 7.51787L4.50611 7.55244L4.49762 7.68432C4.49039 7.79842 4.48025 7.96264 4.46857 8.16336C4.44522 8.56473 4.41572 9.11244 4.39114 9.69745C4.34247 10.8561 4.31125 12.1954 4.3935 12.8135C4.55526 14.0291 5.29361 16.7385 8.13443 17.9656L8.2353 18.0092L8.33562 17.9644C11.038 16.756 11.9436 14.3226 12.1527 12.8149C12.2579 12.0562 12.2047 10.7156 12.1293 9.58833C12.0912 9.01961 12.0468 8.49691 12.0119 8.11647C11.9945 7.92619 11.9794 7.77138 11.9687 7.66403L11.9561 7.54008L11.9527 7.5076L11.9518 7.49923L11.9516 7.49707L11.9516 7.49651L11.9515 7.49635L11.7029 7.52274Z",
        fill: "#E31D1C",
        stroke: "white",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_1465",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "7",
        width: "9",
        height: "12",
        children: /*#__PURE__*/_jsx("path", {
          d: "M11.7029 7.52274L11.9515 7.49629L11.9277 7.27274H11.7029H4.75862H4.52491L4.50919 7.50592L4.75862 7.52274L4.50918 7.50598L4.50917 7.50613L4.50913 7.50672L4.50898 7.50899L4.50839 7.51787L4.50611 7.55244L4.49762 7.68432C4.49039 7.79842 4.48025 7.96264 4.46857 8.16336C4.44522 8.56473 4.41572 9.11244 4.39114 9.69745C4.34247 10.8561 4.31125 12.1954 4.3935 12.8135C4.55526 14.0291 5.29361 16.7385 8.13443 17.9656L8.2353 18.0092L8.33562 17.9644C11.038 16.756 11.9436 14.3226 12.1527 12.8149C12.2579 12.0562 12.2047 10.7156 12.1293 9.58833C12.0912 9.01961 12.0468 8.49691 12.0119 8.11647C11.9945 7.92619 11.9794 7.77138 11.9687 7.66403L11.9561 7.54008L11.9527 7.5076L11.9518 7.49923L11.9516 7.49707L11.9516 7.49651L11.9515 7.49635L11.7029 7.52274Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.5"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_1465)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.39673 7.94226C7.39673 7.94226 7.5516 8.17823 7.62093 8.53904C7.69026 8.89985 7.70221 9.3103 7.70221 9.3103L6.52916 9.12941V10.4651L7.73504 10.2738L7.69897 11.6745C7.69897 11.6745 7.54573 11.7211 7.1772 11.6745C6.80866 11.6279 6.08264 11.4328 6.08264 11.4328V12.708C6.08264 12.708 6.82027 12.4721 7.1772 12.4179C7.53413 12.3638 7.69897 12.4179 7.69897 12.4179L7.71062 13.6408H8.90667L8.89501 12.4179C8.89501 12.4179 9.27142 12.36 9.66905 12.4227C10.0667 12.4854 10.4439 12.708 10.4439 12.708V11.4328C10.4439 11.4328 10.0617 11.6231 9.70132 11.6705C9.34091 11.7179 8.89501 11.6745 8.89501 11.6745L8.93108 10.2738C8.93108 10.2738 9.13984 10.2222 9.41975 10.2602C9.69966 10.2982 10.05 10.4651 10.05 10.4651V9.12941C10.05 9.12941 9.70854 9.31522 9.43987 9.34892C9.17119 9.38263 8.89826 9.3103 8.89826 9.3103C8.89826 9.3103 8.90824 8.87964 8.96601 8.56197C9.02378 8.2443 9.18737 7.94226 9.18737 7.94226H7.39673Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.173 15.1839C5.173 15.1839 5.50262 14.4765 6.03897 14.342C6.57533 14.2074 7.13774 14.7629 7.13774 14.7629C7.13774 14.7629 7.48116 13.6406 8.31824 13.6406C9.15532 13.6406 9.44909 14.7629 9.44909 14.7629C9.44909 14.7629 9.80624 14.342 10.3198 14.342C10.8334 14.342 11.3092 15.1839 11.3092 15.1839C11.3092 15.1839 9.77517 17.969 8.24112 17.969C6.70706 17.969 5.173 15.1839 5.173 15.1839Z",
          fill: "#2E42A5"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Slovakia.js.map